<nav class="nav-v3" (click)="closeMenus()">

  @for (slot of visiblePrimary(); track slot.id) {
    <div class="nav-slot">
      <a
        class="nav-item"
        [class.active]="activeSlotId() === slot.id"
        [class.calc-active]="slot.id === 'calculator' && activeSlotId() === 'calculator'"
        [routerLink]="slot.route"
      >
        {{ slot.label }}
        <!-- @if (slot.hasDropdown) {
          <span class="nav-caret" (click)="onCalculatorDropdownClick($event)">▾</span>
          @if (slot.id === 'calculator' && activeCalcVariant()) {
            <span class="calc-variant-badge">{{ activeCalcVariant() }}</span>
          }
        } -->
      </a>

      <!-- @if (slot.id === 'calculator' && calcMenuOpen()) {
        <ul class="calc-menu" (click)="$event.stopPropagation()">
          @for (v of calcVariants; track v.id) {
            <li>
              <a
                [routerLink]="v.route"
                [class.active]="activeCalcVariant() === v.id"
                (click)="closeCalcMenu()"
              >
                <span class="calc-menu-badge">{{ v.id }}</span>
                <span class="calc-menu-label">{{ v.label }}</span>
              </a>
            </li>
          }
        </ul>
      } -->
    </div>
  }

  <!-- <button
    class="nav-overflow"
    type="button"
    [class.active]="overflowOpen() || !!activeOverflowSlot()"
    (click)="$event.stopPropagation(); toggleOverflow()"
  >
    More <span class="caret">▾</span>
    @if (activeOverflowSlot()) {
      <span class="overflow-active-hint">· {{ activeOverflowSlot()!.label }}</span>
    }
  </button> -->

  @if (overflowOpen()) {
    <ul class="overflow-menu" (click)="$event.stopPropagation()">
      @for (slot of visibleOverflow(); track slot.id) {
        <li>
          <a
            [routerLink]="slot.route"
            [class.active]="activeSlotId() === slot.id"
            (click)="closeOverflow()"
          >{{ slot.label }}</a>
        </li>
      }
    </ul>
  }

  @if (showDevContext()) {
    <div class="nav-context">
      <!-- <span class="dev-pill">DEV</span> -->
      <span class="context-text">{{ session.companyName() || '—' }}</span>
    </div>
  }

</nav>
